import type { StorageAdapter } from '../../core/adapters/StorageAdapter'

export function createMemoryStorageAdapter(): StorageAdapter {
  const store = new Map<string, string>()

  return {
    getItem: (key) => store.get(key) ?? null,
    setItem: (key, value) => {
      store.set(key, value)
    },
    removeItem: (key) => {
      store.delete(key)
    },
  }
}

export function createBrowserLocalStorageAdapter(): StorageAdapter {
  if (typeof localStorage === 'undefined') {
    return createMemoryStorageAdapter()
  }

  return {
    getItem: (key) => localStorage.getItem(key),
    setItem: (key, value) => localStorage.setItem(key, value),
    removeItem: (key) => localStorage.removeItem(key),
  }
}
